import React ,{useState,useEffect} from 'react';
import NavigationBar from './components/NavigationBar';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import TestimonialSlider from './components/TestimonialSlider';
import Product from './components/Product';
import PastWorks from './components/PastWorks';
import Swipercomponent from './components/Swiper';
import ScrollToTopButton from './components/ScrollToTopButton';

import ProductDetails from './components/ProductDetails'; // New component
import { Routes, Route } from 'react-router-dom';
import data from './data.json'; 
import ContactUs from './components/ContactUs';
import Navbar from './components/Navbar/Navbar';

function App() {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => {
    
    setTestimonials(data.testimonials);
  }, []);
  
  return (
    <div >
      {/* <Navbar/> */}
      <NavigationBar/>
      <Routes>
        <Route path="/" element={<><Swipercomponent /><ContactForm /><Product /><PastWorks /><TestimonialSlider testimonials={testimonials} /></>} />
        <Route path="/product/product-details/:id" element={<ProductDetails />} />
        <Route path="/contactus" element={<ContactUs/>} />
        <Route path="/products" element={<Product/>} />
      </Routes>
      <FloatingWhatsApp />
      <ScrollToTopButton />
      <Footer />
    </div>
  );
}

export default App;
